import { defineComponent, createElementBlock, openBlock, normalizeClass, createElementVNode, renderSlot, createVNode, withCtx } from 'vue';
import _sfc_main$1 from './basler-components.es153.js';
/* empty css                        */

const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "accordion-section__inner" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AccordionSection",
  props: {
    id: {},
    colorMode: { default: "light" },
    openMultipleItems: { type: Boolean, default: false },
    itemHeadingLevel: { default: 3 },
    state: {}
  },
  emits: ["update:state"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: _ctx.id,
        class: normalizeClass([
          "accordion-section",
          "accordion-section--color-" + _ctx.colorMode,
          { "theme-light": _ctx.colorMode === "light" || _ctx.colorMode === "white" },
          { "theme-dark": _ctx.colorMode === "dark" || _ctx.colorMode === "black" }
        ])
      }, [
        createElementVNode("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "headline"),
          createVNode(_sfc_main$1, {
            "open-multiple-items": _ctx.openMultipleItems,
            "item-heading-level": _ctx.itemHeadingLevel,
            state: _ctx.state,
            "onUpdate:state": _cache[0] || (_cache[0] = ($event) => emit("update:state", $event))
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["open-multiple-items", "item-heading-level", "state"])
        ])
      ], 10, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
